module.exports = __webpack_public_path__ + "assets/webgl/card_052_DE_L0.81357453.jpg";